module.exports = __webpack_public_path__ + "img/works_kuraray_miniapp_3@2x.72178a47.png";